import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CrpRepository } from '../../core/domain/car-rental-policy/repositories/crp.repository';
import { CrpImplRepository } from './crp-impl.repository';
import { PostCrpUseCase } from '@/core/domain/car-rental-policy/usecases/postCrp.usecase';

const PostCrpUseCaseFactory = (crpRepository: CrpRepository) =>
    new PostCrpUseCase(crpRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: PostCrpUseCase,
            useFactory: PostCrpUseCaseFactory,
            deps: [CrpRepository],
        },
        {
            provide: CrpRepository,
            useClass: CrpImplRepository,
        },
    ],
})
export class CrpDataModule {}
